var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ap-button",class:_vm.setWrapperClass(),attrs:{"title":"Add candidate to job request"},on:{"click":_vm.openModal}},[_c('i',{staticClass:"add-application-button flaticon-file-2"})])}
var staticRenderFns = []

export { render, staticRenderFns }